let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fJ02p")).then(() => parcelRequire('1Rh0S'));